import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { UiButtonComponent } from '@marianaLinoGit/model-ui-kit';
import { TranslateModule } from '@ngx-translate/core';
import { AppUpdateService } from 'app/core/services/app-update.service';
import { ToastHostComponent } from 'app/shared/toast-host/toast-host';

@Component({
	selector: 'app-root',
	imports: [RouterOutlet, ToastHostComponent, TranslateModule, UiButtonComponent],
	templateUrl: './app.html',
	styleUrl: './app.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class App {
	readonly appUpdate = inject(AppUpdateService);

	dismissUpdateBanner(): void {
		this.appUpdate.updateReady.set(false);
	}

	applyUpdate(): void {
		void this.appUpdate.applyUpdate();
	}
}
